import { RealEstateDto } from 'api/real-estate';
import { useCallback, useEffect, useState } from 'react';
import { realEstateAPI } from 'services/swagger-api/realEstateAPI';

interface UseBorrowerBiensResult {
  biens: RealEstateDto[];
  isLoading: boolean;
  hasBiens: boolean;
  reload: () => void;
}

export const useBorrowerBiens = (personneId?: string): UseBorrowerBiensResult => {
  const [biens, setBiens] = useState<RealEstateDto[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const load = useCallback(() => {
    if (!personneId) {
      setBiens([]);
      return;
    }
    let cancelled = false;
    setIsLoading(true);
    realEstateAPI
      .getRealEstateByPersonId({ personneId })
      .then((response) => {
        if (!cancelled) {
          setBiens(response?.realEstates ?? []);
        }
      })
      .catch((error) => {
        console.error('Erreur lors du chargement des biens:', error);
        if (!cancelled) setBiens([]);
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [personneId]);

  useEffect(() => {
    load();
  }, [load]);

  return {
    biens,
    isLoading,
    hasBiens: biens.length > 0,
    reload: load
  };
};
